import React, { useCallback, useState, useContext, useEffect } from "react";
import "../assets/css/MiPerfil.css";
import "../assets/css/Login.css";
import Contexto from "../context/Contexto";
import Paises from "../components/Paises";
import CambiarAvatar from "../components/CambiarAvatar";
import Cambiar from "../assets/CCstatics/cambiar.png";
import { Link } from "react-router-dom";
import Check from "../assets/CCstatics/check.png";
import Visto from "../assets/CCstatics/visto.png";
function MiPerfil() {
  const { usuario, cliente, guardarDatos, desconectarUsuario } =
    useContext(Contexto);
  const [searchString, setSearchString] = useState("");
  const [searchUsername, setSearchUsername] = useState("");
  const [instagramUsuario, setInstagramUsuario] = useState("");
  const [discordUsername, setDiscordUsername] = useState("");
  const [paisUsuario, setPaisUsuario] = useState("");
  const [cumple, setCumple] = useState("");
  const [quieroNews, setQuieroNews] = useState("");
  const [conectado, setConectado] = useState(false);
  const [adressEth, setAdressEth] = useState("");
  const [mensaje, setMensaje] = useState("");
  const [cambiemos, setCambiemos] = useState(false);
  const [imagenPerfil, setImagenPerfil] = useState(false);
  const [tieneMeta, setTieneMeta] = useState(true);
  const [linkedin, setLinkedin] = useState("");

  useEffect(() => {
    if (cliente) {
      console.log("Cliente: ", cliente);
      if (cliente.email) {
        setSearchString(cliente.email);
      }
      if (cliente.quieroNews) {
        setQuieroNews(cliente.quieroNews);
      }
      if (cliente.username) {
        setSearchUsername(cliente.username);
      }
      if (cliente.linkedin) {
        setLinkedin(cliente.linkedin);
      }
      if (cliente.instagram) {
        setInstagramUsuario(cliente.instagram);
      }
      if (cliente.discord) {
        setDiscordUsername(cliente.discord.username);
      }
      if (cliente.pais) {
        setPaisUsuario(cliente.pais);
      }
      if (cliente.cumple) {
        setCumple(cliente.cumple);
      }
      if (cliente.QuieroNews) {
        setQuieroNews(cliente.QuieroNews);
      }
      if (cliente.profile_picture) {
        setImagenPerfil(cliente.profile_picture);
      } else {
        setImagenPerfil("https://talleresacolor.com/avatares/avatar1.png");
      }
    }
  }, [cliente]);
  const paisQueViene = (pais) => {
    setPaisUsuario(pais);
  };

  let handleClick = () => {
    console.log("guardame");
    if (cliente.discord) {
      cliente.discord.username = discordUsername;
    }
    guardarDatos("/usuarios/" + usuario.uid, {
      username: searchUsername,
      email: searchString,
      instagram: instagramUsuario,
      discord: cliente.discord ? cliente.discord : "",
      pais: paisUsuario,
      cumple: cumple,
      linkedin: linkedin,
      QuieroNews: quieroNews,
      profile_picture: imagenPerfil,
    });
  };
  const handleCheck = () => {
    setQuieroNews(!quieroNews);
    console.log("quieroNews:", quieroNews);
  };
  useEffect(() => {
    if (localStorage.getItem("estamosConectados") === "true") {
      connect();
    } else {
      disconnect();
    }
  }, []);

  const connect = async () => {
    await window.ethereum
      .request({ method: "eth_requestAccounts" })
      .then((data) => {
        setConectado(true);
        localStorage.setItem("estamosConectados", "true");
        setAdressEth(data);
      });

    localStorage.setItem("estamosConectados", true);
  };

  const disconnect = () => {
    localStorage.removeItem("estamosConectados");
    setAdressEth("");
    setConectado(false);
  };
  let cambiar = () => {
    let dale = !cambiemos;
    setCambiemos(dale);
  };
  let guardarNuevo = (img) => {
    setImagenPerfil(img);
  };

  return (
    <>
      {usuario && (
        <>
          <div className="soporteLogin">
            <div className="login">
              <div className="login__wrapper">
                <p className="titFelicitaciones">¡hola {searchUsername}!</p>{" "}
                {imagenPerfil && (
                  <>
                    <img
                      src={imagenPerfil}
                      alt=""
                      className="foto-de-perfil"
                      onClick={() => {
                        cambiar();
                      }}
                    />
                    <img
                      src={Cambiar}
                      alt=""
                      className="cambio"
                      onClick={() => {
                        cambiar();
                      }}
                    />
                  </>
                )}
                {cambiemos && (
                  <>
                    <CambiarAvatar accion={guardarNuevo}></CambiarAvatar>
                  </>
                )}
                <br />
                Email
                <input
                  type="text"
                  className="formuCC"
                  value={searchString}
                  onChange={(e) => setSearchString(e.target.value)}
                  disabled
                ></input>
                Nombre y Apellido (para certificados)
                <input
                  type="text"
                  className="formuCC"
                  value={searchUsername}
                  placeholder="Nombre y Apellido"
                  onChange={(e) => setSearchUsername(e.target.value)}
                ></input>
                Tu país
                <Paises
                  accion={paisQueViene}
                  seleccionado={paisUsuario}
                  placeholder="Tu país"
                  className="formuCC"
                />
                Tu @instagram
                <input
                  type="text"
                  className="formuCC"
                  value={instagramUsuario}
                  placeholder="tu instagram"
                  onChange={(e) => setInstagramUsuario(e.target.value)}
                ></input>
                Usuario de Discord
                <input
                  type="text"
                  className="formuCC"
                  value={discordUsername}
                  onChange={(e) => setDiscordUsername(e.target.value)}
                ></input>
                Fecha nacimiento dd/mm/yyyy
                <input type="date" className="formuCC"></input>
                <div className="quiero">
                  {/* <input
                    type="checkbox"
                    id="quieroNews"
                    onChange={handleCheck}
                    checked={quieroNews}
                  ></input> */}
                  <div className="vistos2" onClick={handleCheck}>
                    {quieroNews ? (
                      <img src={Check} alt="" />
                    ) : (
                      <img src={Visto} alt="" />
                    )}
                    <label htmlFor="quieroNews">
                      Quiero recibir newsletters.
                    </label>
                  </div>
                </div>
                <button onClick={handleClick} className="formuBT">
                  GUARDAR CAMBIOS
                </button>
              </div>
              <br /> <br />
              <Link to="/restablecer" className="formuBTLiner">
                CAMBIAR CONTRASEÑA
              </Link>
              <br />
              <div onClick={desconectarUsuario} className="formuBTLiner">
                CERRAR SESIÓN
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default MiPerfil;
